import Axios from "axios";

const interceptor = (store) => {
  Axios.interceptors.request.use(
    (conf) => {
      store.dispatch({
        type: "API_PROGRESS",
        payload: true,
      });
      return conf;
    },
    (error) => {
      store.dispatch({
        type: "API_PROGRESS",
        payload: false,
      });
      return Promise.reject(error);
    }
  );
  Axios.interceptors.response.use(
    (next) => {
      store.dispatch({
        type: "API_PROGRESS",
        payload: false,
      });
      return Promise.resolve(next);
    },
    (error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.name === "TokenExpiredError"
      ) {
        localStorage.removeItem("userLoginType");
        store.dispatch({
          type: "USER_LOGOUT",
        });
      }

      // Don't show errors on flight search screen
      const currentPath = window.location.pathname;
      if (currentPath === "/" || currentPath.includes("/flight")) {
        store.dispatch({
          type: "API_PROGRESS",
          payload: false,
        });
        return Promise.reject(error);
      }

      var errorMessage = "";
      if (error && error.response && error.response.status === 500) {
        errorMessage = "Something went wrong. Please try again later.";
      } else if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        Array.isArray(error.response.data.error)
      ) {
        errorMessage = error.response.data.error[0];
      } else if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }

      store.dispatch({
        type: "API_PROGRESS",
        payload: false,
      });

      store.dispatch({
        type: "ERROR_MESSAGE",
        payload: { general: errorMessage },
      });
      return Promise.reject(error);
    }
  );
};

export default {
  interceptor,
};
